export default __webpack_public_path__ + "static/char-s-56-ko-2e4a0ae576ec810106f93a6091aa154d.png";